import BaseEntity from './base/BaseEntity.model';

export default class NameValue extends BaseEntity{
    public codigo?: string;
    public descripcion?: string;
    public comentario?: string;
    public isDefault?: boolean;
    public orderBy?: number;
    public key1?: string;
    public key2?: string;
    public key3?: string;
    public value1?: string;
    public value2?: string;
    public value3?: string;
    constructor(public parentId?: number) {
        super();
    }
    init() {
        this.id = undefined;
        this.codigo = String();
        this.comentario = String();
        this.descripcion = String();
    }
}